<ng-container
  *ngIf="
    !(installationDetailsStore.loaded$ | async) && (installationDetailsStore.loading$ | async);
    else loadedEl
  "
>
  <app-panel data-at-booked-package-card>
    <app-panel-header>
      {{ '+INSTALLATIONS.INSTALLATION.BOOKED_PACKAGE_CARD.TITLE' | translate }}
    </app-panel-header>
  </app-panel>
</ng-container>

<ng-template #loadedEl>
  <app-panel
    *ngIf="installationDetailsStore.getGatewayStatus() | async as gatewayStatus"
    data-at-booked-package-card
    [expandable]="false"
    [expanded]="true"
  >
    <app-panel-header>
      <div class="flex flex-row justify-between items-center">
        <div>{{ '+INSTALLATIONS.INSTALLATION.BOOKED_PACKAGE_CARD.TITLE' | translate }}</div>
        <ng-container *ngIf="installationDetailsStore.ownershipType$ | async as ownershipType">
          <!-- Commercial spinner & badge -->
          <ng-container *ngIf="commercialBadgeOwnershipTypes.includes(ownershipType)">
            <mat-spinner *ngIf="!deviceSubscriptionPlan"></mat-spinner>
            <app-booking-package-badge
              [attr.data-at-booked-package]="deviceSubscriptionPlan"
              size="small"
              *ngIf="deviceSubscriptionPlan"
              [packageType]="deviceSubscriptionPlan"
              [isTrial]="installationPackage?.isTrial"
            ></app-booking-package-badge>
          </ng-container>

          <!-- Residential spinner & badge -->
          <ng-container *ngIf="residentialBadgeOwnershipTypes.includes(ownershipType)">
            <mat-spinner *ngIf="!isActiveSubscriptionsLoaded || !installationPackage"></mat-spinner>
            <app-booking-package-badge
              [attr.data-at-booked-package]="installationPackage?.plan || BookingPlans.Basic"
              size="small"
              *ngIf="shouldDisplayBadgeForResidential$ | async"
              [packageType]="installationPackage?.plan || BookingPlans.Basic"
              [isTrial]="installationPackage?.isTrial"
            ></app-booking-package-badge>
          </ng-container>
        </ng-container>
      </div>
    </app-panel-header>
    <app-panel-content
      *ngIf="
        (bookingStore.hasAccessToBooking$ | async) &&
        (installationPackage?.plan === BookingPlans.Basic ||
          installationPackage?.plan === BookingPlans.Free ||
          installationPackage?.plan === BookingPlans.Plus) &&
        isActiveSubscriptionsLoaded &&
        !!installationPackage
      "
      class="flex flex-col tooltip-wrapper"
    >
      <button
        *ngIf="
          installationPackage?.plan === BookingPlans.Plus &&
          (installationDetailsStore.isPermamentInspectionFeatureSupported$ | async)
        "
        data-at-booked-package-card-buy-pro-btn
        mat-stroked-button
        color="accent"
        gtm="onGoToPage"
        gtmAction="Booking"
        gtmCategory="bookedPackageCard"
        (click)="onUpgradeToPro()"
      >
        {{ '+INSTALLATIONS.INSTALLATION.BOOKED_PACKAGE_CARD.UPGRADE_TO_PRO' | translate }}
      </button>
      <div
        [matTooltip]="
          gatewayPlatformType === platform.None
            ? ('+BOOKING.DEVICES.TOOLTIP.OFFLINE_INSTALLATION' | translate)
            : null
        "
        class="tooltip-wrapper"
      >
        <button
          *ngIf="
            boilerSerial &&
            (installationPackage?.plan === BookingPlans.Basic ||
              installationPackage?.plan === BookingPlans.Free)
          "
          data-at-booked-package-card-buy-package-btn
          [attr.data-at-disabled]="gatewayPlatformType === platform.None"
          mat-stroked-button
          [color]="gatewayPlatformType === platform.None ? 'primary' : 'accent'"
          gtm="onGoToPage"
          gtmAction="Booking"
          gtmCategory="bookedPackageCard"
          [disabled]="gatewayPlatformType === platform.None"
          (click)="onBuyPackage()"
        >
          <p>{{ '+INSTALLATIONS.INSTALLATION.BOOKED_PACKAGE_CARD.BUY_PACKAGE' | translate }}</p>
        </button>
      </div>
    </app-panel-content>
    <!-- Renew Voucher Subscription -->
    <app-panel-content
      *ngIf="bookingStore.canVoucherBeRenew(installationPackage?.boilerSerial) | async"
      class="flex flex-col tooltip-wrapper"
    >
      <p class="renew-description">
        {{ '+INSTALLATIONS.INSTALLATION.BOOKED_PACKAGE_CARD.RENEW_VOUCHER' | translate }}
      </p>
      <button
        mat-stroked-button
        color="accent"
        gtm="onOpen"
        gtmaction="Renew pro subscription"
        gtmcategory="bookingOverview"
        (click)="onRenewSubscription()"
      >
        {{ '+BOOKING.OVERVIEW.VOUCHER.RENEW_SUBSCRIPTION' | translate }}
      </button>
    </app-panel-content>
    <app-panel-content
      *ngIf="
        !(bookingStore.hasAccessToBooking$ | async) &&
        (installationPackage?.plan === BookingPlans.Basic ||
          installationPackage?.plan === BookingPlans.Free) &&
        gatewayStatus?.offline
      "
    >
      <div class="content-description">
        {{ '+INSTALLATIONS.INSTALLATION.BOOKED_PACKAGE_CARD.NO_PACKAGE_DESCRIPTION' | translate }}
      </div>
    </app-panel-content>
    <!-- Higher package bought but new features are not ready -->
    <app-panel-content
      *ngIf="
        ((bookingStore.hasAccessToBooking$ | async) &&
          installationPackage?.plan === BookingPlans.Plus &&
          (installationDetailsStore.availablePaidFeatures$ | async)?.length < 16) ||
        (installationPackage?.plan === BookingPlans.Pro &&
          (installationDetailsStore.availablePaidFeatures$ | async)?.length < 20)
      "
    >
      <div class="content-description">
        {{ '+INSTALLATIONS.INSTALLATION.BOOKED_PACKAGE_CARD.FEATURES_NOT_READY' | translate }}
      </div>
    </app-panel-content>
  </app-panel>
</ng-template>
